import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import type { Workbox } from 'workbox-window';

// SW 更新事件橋接（連接 SW registration callback → React UI）
export const swUpdateEvent = new EventTarget();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 註冊 Service Worker（僅 production build 生效）
serviceWorkerRegistration.register({
  onUpdate: (_registration: ServiceWorkerRegistration, wb: Workbox) => {
    // 僅派發事件 → UpdateNotification 顯示「系統更新可用」，由使用者按「立即更新」才重載。
    // 不再自動 window.location.reload()：會在使用者查詢/操作到一半時強制重載並掉回預設頁。
    // 若延後更新期間載到已失效的 chunk，App 的 lazyWithRetry 會在該時點自動重載作為安全網。
    swUpdateEvent.dispatchEvent(
      new CustomEvent('sw-update', { detail: { wb } })
    );
  },
  onSuccess: () => {
    console.log('[SW] 離線快取已就緒。');
  },
});
